import { colors } from '@btime/constants'
import React from 'react'

import { Text } from '../presentation/Text'
import FlexGrid, { FlexColumn } from '../structure/FlexGrid'
import Icon from '../shapes/Icon'
import Link from '../actions/Link'
import ListItemWrapper from './ListItemWrapper'
import Separator from '../helpers/Separator'

const FilterListItem = ({ onClick, label, cleanValue, value, icon, disabled, isSelected, onClear }) => {
  let valueDOM = (
    <Text color={colors.dark2} bold>
      {value}
    </Text>
  )
  if (cleanValue) valueDOM = value
  return (
    <ListItemWrapper>
      <Link onClick={onClick} block disabled={disabled}>
        <FlexGrid>
          <FlexColumn flex={2}>
            <Text size={value ? 'xxsmall' : 'p'} color={colors.dark2} weight={isSelected && 800}>
              {label}
            </Text>
            {valueDOM}
          </FlexColumn>
          <Separator vertical />
          {isSelected && onClear && (
            <FlexColumn flex={0.15}>
              <Icon
                name="BsTrash"
                color={colors.red}
                size=".85rem"
                onClick={event => {
                  event.stopPropagation()
                  onClear()
                }}
              />
            </FlexColumn>
          )}
          <FlexColumn flex={0}>
            <Icon name={icon || 'BsPencil'} color={colors.dark3} size=".85rem" />
          </FlexColumn>
        </FlexGrid>
      </Link>
    </ListItemWrapper>
  )
}

export default FilterListItem
